import _ from 'lodash';
import { mixed } from 'yup';
import type { UUID } from '@util/uuid';

export const makeEnumSchema = <T extends string>(values: readonly T[]) => mixed<T>().oneOf(values as T[]);
export const makeUUIDSchema = <T extends UUID<string>>() =>
    mixed<T>()
        .test('is string', '${path} is not string', (t: any): t is T => t === undefined || typeof t === 'string')
        .strict();

export const convertSnakeCaseIntoCamelCase = (key: string) => {
    const parts = key.split('_');
    for (let i = 1; i < key.length; i++) {
        let part = parts[i];
        if (part === 'id') {
            // id is a special case
            part = 'ID';
        } else {
            part = _.capitalize(part);
        }
        parts[i] = part;
    }

    return parts.join('');
};
